import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { errorMessages } from '~/constants/errorMessages.ts';
import api from '~/libs/api';
import { TPosition } from './types';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/store';

const getPositions = (token: string) => async () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
  try {
    const { data } = await api.get(`/dictionary-service/dictionary/positions`, { headers });
    return data;
  } catch {
    throw Error(errorMessages.SERVICE_UNAVAILABLE);
  }
};

export const usePositionsQuery = () => {
  const token = useSelector((state: RootState) => state.users.token);
  const { data, error, isLoading, isError } = useQuery<TPosition[]>({
    queryKey: ['positions'],
    queryFn: getPositions(token),
    staleTime: 30 * 60 * 1000,
  });

  const positionOptions: TAutocompleteOption[] = useMemo(() => {
    if (!data) return [];
    return data
      .map((currency) => ({
        value: currency.id.toString(),
        label: currency.name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [data]);

  return { positionOptions, positions: data, error, isLoading, isError };
};
